/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_multiply = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiply`)
};

const es_fr_multiply = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplicar`)
};

const de_fr_multiply = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplizieren`)
};

const nl_fr_multiply = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vermenigvuldigen`)
};

const fr_fr_multiply = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplier`)
};

const it_fr_multiply = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moltiplica`)
};

const pt_br2_fr_multiply = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplicar`)
};

const pt_fr_multiply = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplicar`)
};

const ja_fr_multiply = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`掛け算`)
};

const zh_fr_multiply = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`乘法`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_multiply = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_multiply(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_multiply", locale)
	if (locale === "en") return en_fr_multiply(inputs)
	if (locale === "es") return es_fr_multiply(inputs)
	if (locale === "de") return de_fr_multiply(inputs)
	if (locale === "nl") return nl_fr_multiply(inputs)
	if (locale === "fr") return fr_fr_multiply(inputs)
	if (locale === "it") return it_fr_multiply(inputs)
	if (locale === "pt-BR") return pt_br2_fr_multiply(inputs)
	if (locale === "pt") return pt_fr_multiply(inputs)
	if (locale === "ja") return ja_fr_multiply(inputs)
	return zh_fr_multiply(inputs)
};